export const TITLE = "SCHÄDEN";
export const COMPANY_ID = "SN";
export const COMPANY_NAME = "KUNDE";
export const ERROR_LOAD = "Der Schaden konnte nicht geladen werden. Bitte erneut versuchen.";
